import {formatId, parseId} from 'core/common/utils/utils';
import MdField, {FIELDTYPE, VALUESOURCETYPE} from "core/metamodel/mdField";
import {FILTEROPERATOR, GridLocation, GridLocationField, HasAccessToEntity} from "core/grid/domain/grid";
import {observable} from "mobx";
import {DomainAncestor, entityConfig} from "core/common/domain/DomainAncestor";
import {ID} from "core/metamodel/metaConstant";
import MdEntity from "core/metamodel/mdEntity";
import {isLovValueObjectOnly} from "core/common/utils/jsonUtils";
import {lovValue, replaceIdWithLov} from "core/form/formUtils";
import mdEntityService from "core/metamodel/mdEntityService";
import GridConfig from "core/grid/domain/gridConfig";

@entityConfig()
export default class GridConfigCondition extends DomainAncestor {

  // reference na gridLocation nebo gridConfig
  private $entitySource: HasAccessToEntity;

  @observable field: MdField;

  @observable public operator: FILTEROPERATOR;

  // array of values;
  @observable public values: any[];

  public implicit: boolean;

  public superFilter: boolean;

  constructor (entitySource: HasAccessToEntity, json: any) {
    super(json);
    this.$entitySource = entitySource;
    if (this.field) this.field = (entitySource && this.field.fieldType !== FIELDTYPE.SQLRESULT) ? entitySource.getEntityRef().getField(this.field.fieldName) : new MdField(this.field);
  }


  public getId(): ID {
    return this.field.fieldKey;
  }

  public setId(id: ID): void {
  }


  get columnName() {
    return (this.field) ? this.field.fieldName : undefined;
  }

  get fieldKey() {
    return (this.field) ? this.field.fieldKey : undefined;
  }

  public getEntityRef(): MdEntity {
    return this.$entitySource.getEntityRef();
  }



  public clone() : GridConfigCondition {
    let newGcc = new GridConfigCondition(this.$entitySource, this);
    if (this.values) newGcc.values = this.values.slice(0);
    return newGcc;
  }

  public convertToLov(): void {
    if (this.values && this.values.length && this.field.valueSourceType === VALUESOURCETYPE.LOCAL) {
      let valueSource = mdEntityService.getEntity(this.field.valueSource);
      this.values = this.values.map(v => replaceIdWithLov(v, valueSource));
    }
  }

  get gridHeaderLabelActive(): string {
    if (this.field) {
      let gridLocation: GridLocation;
      if (this.$entitySource instanceof GridConfig) {
        gridLocation = this.$entitySource.$gridLocationRef;
      } else if (this.$entitySource instanceof GridLocation) {
        gridLocation = this.$entitySource;
      }
      let gridLocationField: GridLocationField = (gridLocation) ? gridLocation.fields.get(this.field.fieldName) : null;
      let headerLabelActive = (gridLocationField) ? gridLocationField.gridHeaderLabel : null;
      return (headerLabelActive != null) ? headerLabelActive : this.field.gridHeaderLabelActive;
    } else {
      return '';
    }
  }

}



// WEBPACK FOOTER //
// ./src/core/grid/domain/gridConfigCondition.ts